import React, { useRef, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import CloseIcon from "@mui/icons-material/Close";
// import VolumeOffIcon from "@mui/icons-material/VolumeOff";
// import VolumeUpIcon from "@mui/icons-material/VolumeUp";
// import FullscreenIcon from "@mui/icons-material/Fullscreen";
// import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

export function AutoCloseIframeVideo({
  videoUrl,
  onClose,
  videoStyle,
  sx,
  ...props
}) {
  console.log("AutoCloseIframeVideo rendered with videoUrl:", videoUrl);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 自动播放视频
    video.play().catch((error) => {
      console.error("视频自动播放失败:", error);
    });

    // 监听视频播放结束事件
    const handleVideoEnd = () => {
      if (onClose) {
        onClose();
      }
    };

    video.addEventListener("ended", handleVideoEnd);

    // 清理事件监听器
    return () => {
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, [onClose]);

  return (
    <Box
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // zIndex: 9999,
        position: "relative",
        ...sx,
      }}
    >
      <video
        controls
        ref={videoRef}
        src={videoUrl}
        style={{
          borderRadius: "8px", // 全屏时移除圆角
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          ...videoStyle,
        }}
        autoPlay
        playsInline // 在移动设备上内联播放
        allowFullScreen
      />

      {/* 关闭按钮 */}
      <IconButton
        onClick={onClose}
        sx={{
          bgcolor: "#799157",
          zIndex: 2,
          mt: 2,
          ":hover": {
            bgcolor: "#5a6f3c",
          },
        }}
      >
        <CloseIcon
          sx={{
            color: "#fff",
          }}
        />
      </IconButton>

      {/* 点击背景也可以关闭 */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
        onClick={onClose}
      />
    </Box>
  );
}
